import React, { useState } from 'react';
import { TELL_ANTHONY, keySaveFor } from '../../services/trackJobsModel';
import './AddTrack.css';

/**
 * "Save as <student>'s key" (2026-09-26, build step 4). Appears beside the key
 * control only once the key is off the file's own key: trying keys in a lesson
 * renders nothing (Anthony: "it shouldn't render each key that we change it
 * to"); this button is the ONE moment a file is rendered, by whichever worker
 * takes the job, and the family can then play and download it. Always renders
 * from the original recording (keySaveFor). Progress shows in the song's job
 * list under the strip, like an added track.
 *
 * Plain <button>; the guard is in the handler as well as `disabled`.
 */
const SaveKeyButton = ({ files = [], player, onSaveKey, who = null }) => {
	const [busy, setBusy] = useState(false);
	const [error, setError] = useState('');
	if (!player || !player.keyAvailable || !onSaveKey || !player.current) return null;
	const plan = keySaveFor(files, player.current.file, player.semitones || 0);
	if (!plan) return null;
	const whose = who ? `${who}'s` : "the student's";

	const onClick = async () => {
		if (busy || !plan) return;
		setBusy(true);
		setError('');
		try {
			await onSaveKey(plan);
		} catch (e) {
			console.error('Save key failed:', e);
			setError((e && e.message) || 'unknown error');
		} finally {
			setBusy(false);
		}
	};

	return (
		<>
			<button type="button" className="tp__pill tk__save" onClick={onClick} disabled={busy} data-testid="save-key">
				<i className={`fa-sharp fa-solid ${busy ? 'fa-spinner-third fa-spin' : 'fa-floppy-disk'}`} aria-hidden="true" />
				{busy ? 'Saving…' : `Save ${plan.label} as ${whose} key`}
			</button>
			{error && (
				<p className="tp__error" role="alert">
					The key could not be saved. {TELL_ANTHONY}
					<span className="at__detail">{error}</span>
				</p>
			)}
		</>
	);
};

export default SaveKeyButton;
